// Safe wrappers around window.localStorage, which is absent while
// prerendering and throws when storage is disabled or over quota.
// Every key is namespaced under the app prefix, so callers pass bare names
// ('welcomeAnimation' is stored as 'tata:welcomeAnimation').

const STORAGE_PREFIX = 'tata:';

export function getStorageItem(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_PREFIX + key);
  } catch {
    return null;
  }
}

export function setStorageItem(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, value);
  } catch {
    // Ignore storage errors (disabled storage, quota)
  }
}

export function removeStorageItem(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_PREFIX + key);
  } catch {
    // Ignore storage errors (disabled storage, quota)
  }
}
